var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer bgBlk"},[_c('div',{staticClass:"container"},[_c('p',[_c('span',{staticClass:"whtTxt link",on:{"click":function($event){$event.stopPropagation();return _vm.openTerms.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.getText('f001')))])]),_c('hr'),_c('p',[_vm._v(" © "+_vm._s(_vm.currentYear)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }